import { useContext } from 'react';

import DataContext from '../../contexts/DataContext';
import Button from '../../components/Button';
import { isMobile } from '../../helpers';
import infoIcon from '../../images/info-white-circle.svg';
import microinverterGraphic from '../../images/microinverter.png';

import Slide from '../components/Slide';
import { UpgradeSystem } from '../enums';
import { upgradeMicroinverters } from '../data/pages';

export default function UpgradeMicroinverters() {
  const { data } = useContext(DataContext);
  const { button, dataKey, heading } = upgradeMicroinverters;
  const isBatteryOnly = data.upgradeSystem === UpgradeSystem.Battery;

  return (
    <>
      <Slide dataKey={dataKey} heading={heading} />
      <div
        className={`relative w-full h-[165px] rounded-2xl bg-gradient-to-b from-[#FF8B49] to-[#F7D9A9] my-8 overflow-hidden`}>
        <img
          alt="Microinverter graphic"
          className="absolute top-[-43px] right-12 w-[400px]"
          src={microinverterGraphic}
        />
      </div>
      {isBatteryOnly && (
        <div className="flex items-center bg-[#FFF2F2] rounded-xl my-10 p-3">
          <img alt="Info icon" src={infoIcon} className="mr-2" />
          <p className="text-[14px] font-medium text-[#CC0F0F]">
            Your existing Enphase system needs to be upgraded to the latest
            IQ-series microinverters to add storage.
          </p>
        </div>
      )}
      <p className="text-[16px] md:text-[18px] md:max-w-[480px]">
        To upgrade your microinverters, please call{' '}
        {isMobile() ? (
          <a className="underline" href="tel:+18339633820">
            (833) 963-3820
          </a>
        ) : (
          '(833) 963-3820'
        )}{' '}
        or visit our Upgrade program page.
      </p>
      <div className="mt-[50px] md:mt-[30px]">
        <Button
          action={() => window.location.assign(button.url)}
          className="md:w-[250px]"
          title={button.title}
          data-zuko-id="upgrade-microinverters_upgrade_program"
        />
      </div>
    </>
  );
}
